<template>
  <div id="app">
    <router-view
      ref="header"
      name="header"
    />
    <div class="main-body">
      <router-view
        ref="navigation"
        name="navigation"
      />
      <router-view
        ref="page"
        class="page"
        :key="$route.fullPath"
      />
    </div>
  </div>
</template>

<script>

import UtilsMixin from "@/mixins/UtilsMixin";

export default {
	name: 'App',

	components: {},

  mixins: [ UtilsMixin ],

  computed: {
    route() {
      return this.$router.currentRoute.value.matched[0];
    }
  },

  watch: {
    route: {
      handler() {
        if (!this.route?.components?.default) {
          document.querySelector('.main-body').classList.add('hidden');
        } else {
          document.querySelector('.main-body').classList.remove('hidden');
        }
      },
      deep: true
    }
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss">
@use "scss/_variables.scss";

*{
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}
#app {
	font-family: variables.$font-secondary;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: variables.$color-text;
	background-color: variables.$color-background;

	.uk-modal-dialog{
		border-radius: 8px;
	}
}
.hidden {
  display: none !important;
}
.main-body{
    background-color: var(--brand-color);
	@media screen and (max-width: 600px) {
		display: flex;
		flex-direction: column-reverse;
		justify-content: start;
		height: 100vh;
	}
	@media screen and (min-width: 601px) {
		display: flex;
	}

	.page{
		margin-top: variables.$header-height;
		@media screen and (max-width: 600px) {
			height: 100%;
			overflow: auto;
		}
		@media screen and (min-width: 601px) {
			border-top-left-radius: 16px;
			width: calc(100% - 110px);
			margin-left: 110px;
			transition: margin-left 0.4s;
		}
		padding: 4vh 2vw;
		background-color: variables.$color-background-primary;
	}
	@media screen and (min-width: 601px) {
		.navigation:hover ~ .page {
			width: calc(100% - 269px);
			margin-left: 269px;
		}
	}

	h1, h2, h3, h4, h5, h6{
		margin: 0;
		font-weight: 500 !important;
		font-family: variables.$font-primary;
		color: variables.$color-header-primary;
		text-transform: none;
	}
	p, ul, ol, dl, pre, address, fieldset, figure {
		margin: 0;
	}
	h1{
		color: variables.$color-header-primary;
		margin-bottom: 3vw;
		font-size: 32px;
		&.muted{
			color: variables.$color-text-secondary;
		}
	}
	h2{
		color: variables.$color-header-primary;
		margin-bottom: 0.5vw;
		font-size: 20px;
		&.muted{
			color: variables.$color-text-secondary;
		}
	}
	h3{
		color: variables.$color-header-primary;
		font-size: 14px;
		margin-bottom: 0.5vw;
		&.muted{
			color: variables.$color-text-secondary;
		}
	}
	h4{
		color: variables.$color-header-primary;
		font-size: 13px;
		margin-bottom: 0.5vw;
		&.muted{
			color: variables.$color-text-secondary;
		}
	}
	h5{
		color: variables.$color-header-primary;
		font-size: 13px;
		margin-bottom: 0.5vw;
		&.muted{
			color: variables.$color-text-secondary;
		}
	}

	a,.link{
		color: variables.$color-link;
		background: none;
		border: none;
		text-decoration: underline;
		cursor: pointer;
		font-size: 12px;
		font-family: variables.$font-primary;

		&:hover{
			color: variables.$color-link-hover;
		}
	}
}

select {
    border: 2px solid #e0e0e0;
    border-radius: 4px;
    height: 3rem;
    font-size: 1rem;
    margin: 0 0 15px 0;
    padding: 0 15px;
    transition: all 0.3s;
    color: #1F3A4D;
    font-family: "Lexend Deca", sans-serif;
	&:focus {
		border-bottom: 2px solid variables.$vl-light-blue;
		outline: none;
	}
}

.va-modal {
	z-index: 50000 !important;
}
</style>
